module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/445e1cd3c7bdfcf00df69be73de214b5.png";